import * as React from "react";

/** Number fields are empty by default: a controlled value of 0 / "0" renders as blank so users type without deleting a pre-filled 0. */
export const blankZero = (v) => (v === 0 || v === "0" ? "" : v);

/** Drop-in for a raw `<input type="number">` — all props pass through, only the zero-blanking is added. */
export const NumberInput = React.forwardRef(function NumberInput(props, ref) {
  const shown = "value" in props ? { value: blankZero(props.value) ?? "" } : {};
  return <input {...props} {...shown} type="number" ref={ref} />;
});
